/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandDcos = createReactComponent("outline", "brand-dcos", "IconBrandDcos", [["path", { "d": "M3 18l18 -12h-18l9 14l9 -14v10l-18 -10z", "key": "svg-0" }]]);

export { IconBrandDcos as default };
//# sourceMappingURL=IconBrandDcos.mjs.map
